import { connect } from 'react-redux'
import GradeSummary from './component'

import NavigationHelper from 'layers/navigation/navigationHelper'

export default connect(null, NavigationHelper.mapDispatchToProps)(GradeSummary)
